<template>
    <div class="image-card">
        <div class="card">

            <div class="card-header">
                <slot name="header">
                    <div v-html="header"></div>
                </slot>
            </div>

            <div class="card-body">

                <slot name="body">
                    <div v-html="body"></div>
                </slot>

            </div>

            <div class="card-footer">
                <slot name="footer">
                    <div v-html="footer"></div>
                </slot>
            </div>

        </div>
    </div>
</template>


<script>
    export default {
        name: "SimpleC",
        props: {
            header: {
                type: String,
                default: "",
            },
            body: {
                type: String,
                default: "",
            },
            footer: {
                type: String,
                default: "",
            },
        },
        setup() {
            return {};
        },
    };
</script>


<style lang="scss">
    // .image-card {
        // width: 100%;
        // height: 100%;

        // a{
        //     text-decoration: underline;
        // }

        // .list-none{
        //     list-style: none;
        // }

        // .card {
        //     border: 0px;
        //     border-radius: 10px;
        //     padding: 10px;
        //     height: 100%;
        //     width: 100%;
        // }
        // .card-header {
        //     background-color: unset;
        //     border: 0px;
        //     font-size: 1rem;
        //     font-weight: 600;
        // }
        // .card-footer {
        //     background-color: unset;
        //     border: 0px;
        // }
    // }
// .image-card{
    .card {
        border: 1px solid var(--card-border-color);
        // border-radius: 1rem;
        transition: box-shadow .3s;
    }
    .card:hover {
        box-shadow: 0 0 21px rgba(33, 33, 33, .2);
        cursor: pointer;
        scale: 1.01;
    }
    .card a{
        color: rgb(var(--site-primary-color-rgb));
    }
// }
</style>